<button type="button" class="btn btn-link modal-close" (click)="cancel()">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke="#03101F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="#03101F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
<div>
  <h6 class="change-package-heading mb-0 pb-0 mt-2 mx-0" mat-dialog-title>
    <span class="py-3 px-0"> {{ !this.data.role.roleId ? "Create" : "Edit" }} Audience</span>
  </h6>
  <div class="content-box role-content-box py-0">
    <div class="row">
      <ng-container [formGroup]="roleForm">
        <div class="row mb-2">
          <div class="col-sm-6 mb-0">
            <label class="black-text edit-role-label mb-1">Audience Type</label>
            <input type="text" [required]="true" formControlName="roleName" class="form-control bg-zircon w400"
              [readOnly]="!canEditName"/>
          </div>
        </div>
        <div>
          <!-- FEATURES -->
           
          <div class="col-sm-12">
            <div class="row">
              <div class="col-md-3">
                <span class="black-text edit-role-label fs-14 mb-1">Add-On Features (optional)</span>
              </div>
              <div class="col-md-9 justify-content-end d-flex">
                <span class="edit-role-label fs-14 mb-0 text-dusty-gray mt2">Here is the list of Add-On Features for your selected package</span>
                <div class="dropdown dropdown-actions view-list-dropdown ms-1 edit-role-label fs-14">
                  <button
                    (click)="featureSelect.open()"
                    class="dropdown-toggle existing-package-btn btn theme-btn-underline w-100" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    View Feature list
                  </button>
                </div>
              </div>
            </div>
            <div class="mb-2">
              <mat-form-field>
                <mat-select #featureSelect  formControlName="features" multiple
                [class.is-invalid]="roleForm.controls['features'].invalid && roleForm.controls['features'].touched"
                (valueChange)="createGroupedFeatures($event)">
                  <mat-select-trigger>
                    <span class="chip-list-head">Added Items:</span>
                    <span class="chip-main">
                      <span *ngFor="let featureGroup of groupedFeatures | keyvalue" >
                        <h4 class="black-text fs-14 mb-1" style="font-weight: bolder; margin-top: 1em;">{{featureGroup.key}}</h4>

                        <span *ngFor="let featureValue of featureGroup.value" 
                        style="display: inline-block;margin-left: 0.25em;font-size: 0.8em;"
                        class="chip-list toolkit-display" title="{{featureValue.featureName}}">
                          <label class="toolkit-display"  >
                            <span class="toolkit-display-name">{{featureValue.featureName}}</span>
                          </label>
                          <a class="close" (click)="$event.stopPropagation();$event.preventDefault();removeFeature(featureValue)">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </span>
                      </span>
                    </span>
                    @if ((roleForm.controls['features'].value?.length || 0) > 0) {
                    <span class="chip-list count" (click)="$event.stopPropagation();$event.preventDefault();previewPopup('Added Feature', 'Feature')">
                      #{{(roleForm.controls['features'].value?.length )}}
                    </span>
                    }
                  </mat-select-trigger>
                  <mat-optgroup *ngFor="let rg of this.availableGroupedFeatures | keyvalue" [label]="rg.key">
                       @for (feature of rg.value; track feature) {
                      <mat-option  
                        [value]="feature">
                          {{feature.featureName}}
                        </mat-option>
                    }
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
              <div *ngIf="(roleForm.controls['features'].invalid && roleForm.controls['features'].touched) || roleForm.controls['features'].dirty">
                <small *ngIf="roleForm.controls['features'].errors?.['required']" class="text-danger fs-13">Feature is required</small>
              </div>
            </div>
          </div>

          <!-- MODULE -->
          <div class="col-sm-12">
            <div class="mb-2">
              <div class="row">
                <div class="col-md-3">
                  <span class="black-text edit-role-label mb-1">Module</span>
                </div>
                <div class="col-md-9 justify-content-end d-flex">
                  <span class="edit-role-label mb-0 text-dusty-gray mt2">Here is the list of modules for your selected package</span>
                  <div class="dropdown dropdown-actions view-list-dropdown edit-role-label ms-1">
                    <button
                      (click)="moduleSelect.open()"
                      class="dropdown-toggle existing-package-btn btn theme-btn-underline w-100" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      View Module List
                    </button>
                  </div>
                </div>
              </div>
              <div class="mb-2">
                <mat-form-field>
                  <mat-select #moduleSelect required formControlName="modules" multiple (selectionChange)="onModuleChange($event)"
                  [class.is-invalid]="roleForm.controls['modules'].invalid && roleForm.controls['modules'].touched">
                    <mat-select-trigger>
                      <span class="chip-list-head">Added Items:</span>
                      <span class="chip-main">
                        <span *ngFor="let moduleValue of roleForm.controls['modules'].value" class="chip-list">{{moduleValue.moduleName}}
                          <a class="close" (click)="$event.stopPropagation();$event.preventDefault(); removeModule(moduleValue)">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </span>
                      </span>
                      @if ((roleForm.controls['modules'].value?.length || 0) > 0) {
                      <span class="chip-list count" (click)="$event.stopPropagation(); $event.preventDefault(); previewPopup('Added Modules','Module')">
                        #{{(roleForm.controls['modules'].value?.length)}}
                      </span>
                      }
                    </mat-select-trigger>
                    @for (module of modules; track module) {
                      <mat-option [value]="module">{{module.moduleName}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <div *ngIf="(roleForm.controls['modules'].invalid && roleForm.controls['modules'].touched) || roleForm.controls['modules'].dirty">
                  <small *ngIf="roleForm.controls['modules'].errors?.['required']" class="text-danger fs-13">Module is required</small>
                </div>
              </div>
            </div>
          </div>
          <!-- Toolkits -->
          <div class="col-sm-12">
            <div class="row">
              <div class="col-md-3">
                <span class="black-text edit-role-label fs-14 mb-1">Analytics Toolkit</span>
              </div>
              <div class="col-md-9 justify-content-end d-flex">
                <span class="edit-role-label fs-14 mb-0 text-dusty-gray mt2">Here is the list of Analytics Toolkits for your selected package</span>
                <div class="dropdown dropdown-actions view-list-dropdown ms-1 edit-role-label fs-14">
                  <button
                    (click)="subcategorySelect.open()"
                    class="dropdown-toggle existing-package-btn btn theme-btn-underline w-100" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    View Analytics Toolkit list
                  </button>
                </div>
              </div>
            </div>
            <div class="mb-2">
              <mat-form-field>
                <mat-select #subcategorySelect required formControlName="subCategories" multiple
                [class.is-invalid]="roleForm.controls['subCategories'].invalid && roleForm.controls['subCategories'].touched"
                (valueChange)="createGroupedValues($event)">
                  <mat-select-trigger>
                    <span class="chip-list-head">Added Items:</span>
                    <span class="chip-main">
                      <span *ngFor="let moduleGroup of groupedSubCategories | keyvalue" >
                        <h4 class="black-text fs-14 mb-1" style="font-weight: bolder; margin-top: 1em;">{{moduleGroup.key}}</h4>

                        <span *ngFor="let subCategoryValue of moduleGroup.value" 
                        style="display: inline-block;margin-left: 0.25em;font-size: 0.8em;"
                        class="chip-list toolkit-display" title="{{subCategoryValue.subCategoryName}}">
                          <label class="toolkit-display"  >
                            <mat-icon style="font-size: 1.8em;" *ngIf="subCategoryValue.subCategoryDisplayName!=null">short_text</mat-icon>
                            <span class="toolkit-display-text" *ngIf="subCategoryValue.subCategoryDisplayName!=null">{{subCategoryValue.subCategoryDisplayName}}</span>
                            <span class="toolkit-display-name">{{subCategoryValue.subCategoryName}}</span>
                          </label>
                          <a class="close" (click)="$event.stopPropagation();$event.preventDefault();removeSubCategory(subCategoryValue)">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </span>
                      </span>
                    </span>
                    @if ((roleForm.controls['subCategories'].value?.length || 0) > 0) {
                    <span class="chip-list count" (click)="$event.stopPropagation();$event.preventDefault();previewPopup('Added Analytics Toolkits', 'SubCategory')">
                      #{{(roleForm.controls['subCategories'].value?.length )}}
                    </span>
                    }
                  </mat-select-trigger>
                  <mat-optgroup *ngFor="let rg of (this.availableGroupedSubCategories??{}) | keyvalue" [label]="rg.key">
                       @for (subCategory of rg.value; track subCategory) {
                      <mat-option 
                        [class.multiline]="subCategory.subCategoryDisplayName!=null" 
                        [value]="subCategory">
                          @if(subCategory.subCategoryDisplayName==null)
                          {
                            {{subCategory.subCategoryName}}
                          }
                          @else {
                            <label class="toolkit-display">
                              <mat-icon >short_text</mat-icon>
                              <span class="toolkit-display-text">{{subCategory.subCategoryDisplayName}}</span>
                              <span class="toolkit-display-name">{{subCategory.subCategoryName}}</span>
                            </label>
                          }
                        </mat-option>
                    }
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
              <div *ngIf="(roleForm.controls['subCategories'].invalid && roleForm.controls['subCategories'].touched) || roleForm.controls['subCategories'].dirty">
                <small *ngIf="roleForm.controls['subCategories'].errors?.['required']" class="text-danger fs-13">Analytics Toolkit is required</small>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="sticky-btns">
    <div class="row">
      <div class="col-sm-12 text-right">
        <button type="button" class="btn theme-btn cancel-package ms-3" [disabled]="roleForm.invalid" (click)="update()">{{ !this.data.role.roleId ? "Create" : "Update" }}</button>
      </div>
    </div>
  </div>
</div>
